<template>
  <div v-if="seatPlan" class="seatplan">
    <div v-if="!!seatPlan.background" v-html="seatPlan.background.svg"></div>
    <Seat
      v-for="seat in seatPlan.seats"
      :key="seat.ItemId"
      :seat-height="seatPlan.background.seatHeight"
      :seat-width="seatPlan.background.seatWidth"
      :seat="seat"
      :prices="prices"
      :basket-items="basketItems"
      @seat-click="seatClick"
    />
  </div>
</template>
<script>
import Seat from '@/components/Seat.vue';
export default {
  components: { Seat },
  props: {
    seatPlan: { type: Object, default: null },
    prices: { type: Object, default: null },
    basketItems: { type: Array, default: null }
  },
  methods: {
    seatClick(seatId) {
      this.$emit('seat-click', seatId);
    }
  }
};
</script>
